module.exports = __webpack_public_path__ + "img/pangao_user_user_bg.14a4c19c.png";